import { buildFullName } from "./queue"
import { readAllData, STORES } from "utility"
import { getByIdOffline } from "./Get_one"
import dayjs from "dayjs"

export async function getCertificatsMedicauxOffline({ page, limit, filters }) {
  let data = await readAllData(STORES.CERTIFICATS)

  data = await Promise.all(
    data.map(async (c) => {
      let patient = c.patient

      if (!patient || typeof patient !== "object") {
        patient = await getByIdOffline(STORES.PATIENTS, c.patientId)
      }

      return {
        ...c,
        patient,
        fullName: c.fullName || buildFullName(patient),
      }
    }),
  )

  if (filters.fullName) {
    const search = filters.fullName.toLowerCase()
    data = data.filter((c) => c.fullName?.toLowerCase().includes(search))
  }

  if (filters.startDate) {
    const start = dayjs(filters.startDate).startOf("day").toDate()
    data = data.filter((c) => {
      const d = c.creationDate || c.createdAt
      return d && new Date(d) >= start
    })
  }

  if (filters.endDate) {
    const end = dayjs(filters.endDate).endOf("day").toDate()
    data = data.filter((c) => {
      const d = c.creationDate || c.createdAt
      return d && new Date(d) <= end
    })
  }

  const totalItems = data.length
  const start = (page - 1) * limit

  return {
    data: data.slice(start, start + limit),
    totalItems,
  }
}
